import { FormattedMessage } from 'react-intl'

export const MyCompaniesMessage = <FormattedMessage id="menu.profile.myCompanies" defaultMessage="Cégeim" />

export const ProfileSettingsMessage = <FormattedMessage id="menu.profile.settings" defaultMessage="Profilbeállítások" />
